const USER_AVATAR_URL = '/avatars/users/{userID}/{size}';
const USER_PROFILE_URL = '/profiles/{userID}';

export function getAvatarURL(userId: string, size: number = 96) {
    return USER_AVATAR_URL.replace('{userID}', userId).replace('{size}', size.toString());
}

export function getProfileURL(userId: string) {
    return USER_PROFILE_URL.replace('{userID}', userId);
}
